import { render, staticRenderFns } from "./headerCommon.vue?vue&type=template&id=5dd86348&scoped=true&"
import script from "./headerCommon.vue?vue&type=script&lang=js&"
export * from "./headerCommon.vue?vue&type=script&lang=js&"
import style0 from "./headerCommon.vue?vue&type=style&index=0&id=5dd86348&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd86348",
  null
  
)

export default component.exports